import { Alert, Box, Grid, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import ErrorBoundary from "features/common/components/ErrorBoundary";
import AnalyticsCard from "features/analytics/components/AnalyticsCard";

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  return (
    <Box sx={{ p: 2, bgcolor: "error.light", borderRadius: 1 }}>
      <Alert severity="error" onClose={resetErrorBoundary}>
        {error.message}
      </Alert>
    </Box>
  );
};

function ChartTest() {
  const [value, setValue] = useState("");

  const chart = useMemo(() => {
    try {
      const parsed = JSON.parse(value);
      if (parsed?.chart) {
        return parsed.chart;
      } else if (parsed?.name) {
        return parsed;
      }
      return {};
    } catch (e) {
      console.error(e);
      return {};
    }
  }, [value]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={7} sx={{ minHeight: "500px" }} spacing={2}>
        {Object.keys(chart).length > 0 && (
          <ErrorBoundary
            fallback={({ error, resetErrorBoundary }) => (
              <ErrorFallback
                error={error}
                resetErrorBoundary={resetErrorBoundary}
              />
            )}
          >
            <Box sx={{ height: 500 }}>
              <AnalyticsCard chart={chart} />
            </Box>
          </ErrorBoundary>
        )}
      </Grid>
      <Grid item xs={5}>
        <TextField
          label="payload"
          helperText="Copy and Paste the payload here"
          fullWidth
          multiline
          rows={10}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Alert severity="info">
          Note: date will be ignored and date picker will be used
        </Alert>
      </Grid>
    </Grid>
  );
}

export default ChartTest;
